import React from 'react';
import { useTheme } from '@mui/material/styles';

import { SnackbarProvider } from 'notistack';

const useStyles = (theme) => ({
  snackbarContainer: {
    whiteSpace: 'pre-wrap !important',
    maxWidth: '500px !important',
  },
  info: {
    backgroundColor: `${theme.palette.text.primary} !important`,
    color: `${theme.palette.background.main} !important`,
  },
  action: {
    // border: '1px solid #ff0000',
    marginLeft: '0px !important',
    paddingLeft: '0px !important',
  },
  root: {
    flexDirection: 'column !important',
    position: 'relative !important',
    paddingRight: '20px !important',
  },
});

export const AnnouncementProvider = (props) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  return (
    <SnackbarProvider
      // classes={{
      //   containerRoot: classes.snackbarContainer,
      //   variantInfo: classes.info,
      //   action: classes.action,
      //   contentRoot: classes.root,
      // }}
      snackbarContentProps={{
        sx: {
          ...classes.snackbarContainer,
          ...classes.info,
          ...classes.action,
          ...classes.root,
        },
      }}
    >
      {props.children}
    </SnackbarProvider>
  );
};
AnnouncementProvider.displayName = 'AnnouncementProvider';
